import SVG from 'react-inlinesvg'
import styled from 'styled-components'
import { IconBaseProps } from './Icon.types'
import { ICON_SMALL_SIZE, ICON_LARGE_SIZE, ICON_MEDIUM_SIZE } from './Icon.consts'

export const IconStyled = styled(SVG).attrs<IconBaseProps>(props => {
  switch (props.size) {
    case 'large':
      return {
        width: `${ICON_LARGE_SIZE}px`,
        height: `${ICON_LARGE_SIZE}px`,
      }
    case 'medium':
      return {
        width: `${ICON_MEDIUM_SIZE}px`,
        height: `${ICON_MEDIUM_SIZE}px`,
      }
    case 'small':
    default:
      return {
        width: `${ICON_SMALL_SIZE}px`,
        height: `${ICON_SMALL_SIZE}px`,
      }
  }
})<IconBaseProps>`
  position: relative;
  flex-shrink: 0;
  fill: currentColor;
  vertical-align: bottom;
`
